// extracted by mini-css-extract-plugin
export default {"checkbox":"_1GU_f","align-items-center":"_201q4","alignItemsCenter":"_201q4","label":"_2M0Rt"};